import React from 'react';
import * as R from 'ramda';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import styles from '../css/Form.module.scss';
import ButtonLeftIcon from '../../../../controls/components/ButtonLeftIcon';
import CenterProgress from '../../../../CenterProgress';
import TextFieldCD from './TextFieldCD';

const buttonStyle = theme => ({
	margin: theme.spacing.unit
});

const containerStyle = {
	position: 'relative',
	display: 'flex',
	//flexWrap: 'wrap',
	flexDirection: 'column',
	backgroundColor: '#474747',
	padding: '48px 8px 16px',
	borderRadius: '4px',
	flex: '1 0 auto',
	overflow: 'visible'
};

const formTitleStyle = {
	position: 'absolute',
	top: '-22px',
	left: '16px',
	padding: '16px',
	borderRadius: '4px ',
	display: 'inline-block'
};

const formControlStyle = theme => ({
	margin: theme.spacing.unit,
	minWidth: 120
});

const textFieldStyle = theme => ({
	marginLeft: theme.spacing.unit,
	marginRight: theme.spacing.unit
});

const menuStyle = {
	whiteSpace: 'pre-wrap'
};

const Form = ({
	onUpdateData,
	data,
	comboBoxData,
	showPassword,
	onShowPassword,
	onSave,
	onCancel,
	formFields,
	validation,
	editing,
	editCmp,
	touched,
	hideCancel,
	formTitle = '',
	buttonLabels = ['SAVE', 'CANCEL'],
	buttonIcons = ['save', 'cancel'],
	alwaysTouched
}) => {
	if (!data || R.isEmpty(data)) {
		return <CenterProgress color="secondary" />;
	}

	const inputProps = editing ? {} : { disabled: true };
	const [okLabel, cancelLabel] = buttonLabels;
	const [okIcon, cancelIcon] = buttonIcons;
	return (
			<form css={containerStyle} noValidate autoComplete="off">
				<div css={formTitleStyle} className={styles.formTitle}>
					{formTitle}
				</div>
				<div className={styles.buttonIsland}>
					{editing ? (
						<>
							{hideCancel ? null : (
								<ButtonLeftIcon
									label={cancelLabel}
									icon={cancelIcon}
									variant="outlined"
									onClick={onCancel}
									aria-label={cancelLabel}
								/>
							)}
							&nbsp;
							<ButtonLeftIcon
								label={okLabel}
								icon={okIcon}
								disabled={
									!R.isEmpty(validation) ||
									(!alwaysTouched && !touched)
								}
								variant="contained"
								aria-label={okLabel}
								onClick={onSave}
								sx={buttonStyle}
								color="secondary"
							/>
						</>
					) : (
						editCmp
					)}
				</div>
				{formFields.map(
					({
						name,
						label,
						type,
						dataSourceName,
						mask,
						helperText,
						disabled,
						shrink
					}) =>
						type === 't' || type === 'p' || type === 'm' ? (
							<TextFieldCD
								name={name}
								label={label}
								sx={textFieldStyle}
								type={type}
								disabled={disabled}
								validation={validation}
								mask={mask}
								inputProps={inputProps}
								shrink={shrink}
								data={data}
								onUpdateData={onUpdateData}
								helperText={helperText}
								showPassword={showPassword}
								onShowPassword={onShowPassword}
							/>
						) : (
							<FormControl
								sx={formControlStyle}
								variant="outlined"
								key={name}>
								<InputLabel
									shrink={data[name] || shrink}
									ref={() => {}}
									htmlFor="outlined-age-simple">
									{label}
								</InputLabel>
								<Select
									disabled={disabled}
									value={data[name] || -1}
									onChange={onUpdateData}
									id={name}
									name={`${name}`}
									displayEmpty
									sx={{ '& .MuiSelect-select': menuStyle }}
									input={
										<OutlinedInput
											label={label}
											name="State"
											id="outlined-age-simple"
										/>
									}
									{...inputProps}>
									<MenuItem value="" disabled>
										Placeholder
									</MenuItem>
									{(comboBoxData[dataSourceName] &&
										comboBoxData[dataSourceName].map(
											({ text, value }) => (
												<MenuItem
													key={text}
													value={value}>
													{text}
												</MenuItem>
											)
										)) ||
										null}
								</Select>
							</FormControl>
						)
				)}
			</form>
	);
};

export default Form;
